module.exports = __webpack_public_path__ + "static/media/bloctoswap-logo-beta.526b4fa3.svg";